import React from 'react';
import { PARAMS } from "../../../../config";
const style = { fontSize: '18px', fontWeight: 'bold' };

const Total = ({ data }) => {
    let td = getValues(data);

    return (
        <tr>
            <td colSpan={3}>Total</td>
            {td}
        </tr>
    );
};

function getValues(row) {
    return PARAMS.map(([ param ]) => {
        const value = row[param];

        return (<td style={style} key={param}>{value}</td>);
    });
}

export default Total;



// WEBPACK FOOTER //
// ./src/scenes/AkFull/components/Table/components/TotalRow/index.js